export default {
  scheduledEvents: [],
  scheduledEvent: undefined,
};
